.datePicker {
  & > div {
    width: 100%;
  }
  
  &.darkMode {
    :global {
      .MuiOutlinedInput-root {
        background: #131b20;
      }
      
      .MuiButtonBase-root  {
        color: #F0F2F5;
      }

      .MuiOutlinedInput-input {
        color: white;
      }
    }
  }
  
  :global {
    .MuiOutlinedInput-input {
      font-weight: 300;
    }

    .MuiOutlinedInput-input[value=''] {
      color: #7a838e;
    }
    
    .MuiOutlinedInput-root, .MuiOutlinedInput-input {
      height: 42px;
    }

    .MuiOutlinedInput-input {
      padding: 0 0 0 14px;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-width: 2px !important;
      border-color: #2684FF !important;
    }
    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline {
      border-width: 1px;
      border-color: #b3b3b3;
    }
  }
}
